const isAdminOrDesigner = (userContext) => userContext?.roles?.admin || userContext?.roles?.designer;

export default isAdminOrDesigner;
